import { styled } from 'stitches.config'

export const ReviewRoot = styled('div', {
  color: '$primary-800',
})
